// extracted by mini-css-extract-plugin
export var lbContainerOuter = "B_vm";
export var lbContainerInner = "B_vn";
export var movingForwards = "B_vp";
export var movingForwardsOther = "B_vq";
export var movingBackwards = "B_vr";
export var movingBackwardsOther = "B_vs";
export var lbImage = "B_vt";
export var lbOtherImage = "B_vv";
export var prevButton = "B_vw";
export var nextButton = "B_vx";
export var closing = "B_vy";
export var appear = "B_vz";